/* tslint:disable */
/* eslint-disable */
/**
 * Venue Loyalty API
 * Onyx Gaming Venue Loyalty API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';
import type { SearchPlayerEmail200ResponseResults } from './SearchPlayerEmail200ResponseResults';
import {
    SearchPlayerEmail200ResponseResultsFromJSON,
    SearchPlayerEmail200ResponseResultsFromJSONTyped,
    SearchPlayerEmail200ResponseResultsToJSON,
    instanceOfSearchPlayerEmail200ResponseResults,
} from './SearchPlayerEmail200ResponseResults';

/**
 * 
 * @export
 * @interface SearchPlayerEmail200Response
 */
export interface SearchPlayerEmail200Response {
    /**
     * 
     * @type {SearchPlayerEmail200ResponseResults}
     * @memberof SearchPlayerEmail200Response
     */
    results?: SearchPlayerEmail200ResponseResults;
}


/**
 * Check if a given object implements the SearchPlayerEmail200Response interface.
 */
export function instanceOfSearchPlayerEmail200Response(value: object): boolean {
    let isInstance = true;
    return isInstance;
}

export function SearchPlayerEmail200ResponseFromJSON(json: any): SearchPlayerEmail200Response {
    return SearchPlayerEmail200ResponseFromJSONTyped(json, false);
}

export function SearchPlayerEmail200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchPlayerEmail200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'results': !exists(json, 'results') ? undefined : SearchPlayerEmail200ResponseResultsFromJSON(json['results']),
    };
}

export function SearchPlayerEmail200ResponseToJSON(value?: SearchPlayerEmail200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'results': SearchPlayerEmail200ResponseResultsToJSON(value.results),
    };
}

